import { createReducer, on } from '@ngrx/store';
import * as AiChatActions from '../actions/ai-chat.actions';
import { ChatMessage } from '../../interfaces/chat-message.interface';

export interface AiChatState {
  messages: ChatMessage[];
  loading: boolean;
  messageLoading: boolean;
  error: Error | null;
  token: string | null;
}

export const initialState: AiChatState = {
  messages: [],
  loading: false,
  messageLoading: false,
  error: null,
  token: null,
};

export const aiChatReducer = createReducer(
  initialState,
  on(AiChatActions.CreateChatSession, (state) => ({ ...state, loading: true, error: null })),
  on(AiChatActions.CreateChatSessionSuccess, (state, { token }) => ({
    ...state,
    messages: [],
    loading: false,
    error: null,
    token,
  })),
  on(AiChatActions.CreateChatSessionFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AiChatActions.SendMessage, (state, { message }) => ({
    ...state,
    messages: [...state.messages, message],
    messageLoading: true,
    error: null,
  })),
  on(AiChatActions.SendMessageSuccess, (state, { response }) => ({
    ...state,
    messages: [...state.messages, response],
    messageLoading: false,
    error: null,
  })),
  on(AiChatActions.SendMessageFail, (state, { error }) => ({
    ...state,
    messageLoading: false,
    error,
  })),
  on(AiChatActions.CloseChatSession, (state) => ({ ...state, loading: true, error: null })),
  on(AiChatActions.CloseChatSessionSuccess, (state) => ({
    ...state,
    messages: [],
    loading: false,
    error: null,
    token: null,
  })),
  on(AiChatActions.CloseChatSessionFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
